import { deepCopy } from "@perxis-auto/shared";
import { FilterPathOperatorEnum } from "../../../types/filterPath.js";
import { splitCompositeFilterField } from "../../filterPath/splitCompositeFilterField.js";
const formatExtRawFilterValuesItem = (extRawFilterValuesItem) => {
  const extFilterValues = deepCopy(extRawFilterValuesItem.data);
  const nestedFilterReferenceValues = {};
  const filterRangeValues = {};
  Object.entries(extFilterValues).forEach(([key, value]) => {
    var _a;
    const { key: filterKey, field, operator } = splitCompositeFilterField(key);
    if (FilterPathOperatorEnum.NestedField === operator && field) {
      if (Array.isArray(value)) {
        const references = value;
        references.forEach((ref) => {
          if ((ref == null ? void 0 : ref[field.key]) === field.value) {
            if (nestedFilterReferenceValues[filterKey]) {
              if (!nestedFilterReferenceValues[filterKey].find((r) => r.id === ref.id)) {
                nestedFilterReferenceValues[filterKey].push(ref);
              }
            } else {
              nestedFilterReferenceValues[filterKey] = [ref];
            }
          }
        });
        delete extFilterValues[key];
      }
    }
    if (FilterPathOperatorEnum.Min === operator || FilterPathOperatorEnum.Max === operator) {
      if (!Array.isArray(value)) {
        const resolvedValue = value;
        const rangeValues = ((_a = filterRangeValues == null ? void 0 : filterRangeValues[filterKey]) == null ? void 0 : _a.slice()) || [];
        if (FilterPathOperatorEnum.Min === operator) {
          rangeValues.unshift(resolvedValue || 0);
        } else {
          rangeValues.push(resolvedValue || 0);
        }
        filterRangeValues[filterKey] = rangeValues;
        delete extFilterValues[key];
      }
    }
  });
  return {
    ...extRawFilterValuesItem,
    data: {
      ...extFilterValues,
      ...nestedFilterReferenceValues,
      ...filterRangeValues
    }
  };
};
export {
  formatExtRawFilterValuesItem
};
